import type { DocumentFlagProjection, Flag } from '~/shared/api/data-ingestion-api/client'

export function isFlagNote(flag: Flag | DocumentFlagProjection): boolean {
  if (flag.flag_type?.startsWith('step_')) {
    return true
  }
  return (
    flag.flag_type === 'patient_claim' &&
    (flag.metadata as Record<string, unknown> | null | undefined)?.reviewed === true
  )
}
